import { apiFetch } from "./apiFetch";

export interface Project {
	id: string;
	name: string;
	description?: string | null;
	isActive: boolean;
	userId: string;
	createdAt: string;
	updatedAt: string;
	_count?: {
		modelConfigs: number;
		apiKeys: number;
	};
}

export interface ProjectListResponse {
	data: Project[];
	meta?: {
		page: number;
		limit: number;
		total: number;
	};
}

export interface CreateProjectPayload {
	name: string;
	description?: string | null;
}

export const projectService = {
	list: async (): Promise<Project[]> => {
		// Defaults: first page, generous limit for picker
		return apiFetch<Project[] | ProjectListResponse>(
			"/projects?page=1&limit=50",
		).then((res) => {
			if (Array.isArray(res)) return res;
			if (res && Array.isArray(res.data)) return res.data;
			return [];
		});
	},
	create: async (payload: CreateProjectPayload): Promise<Project> => {
		const response = await apiFetch<Project | { data: Project }>("/projects", {
			method: "POST",
			body: JSON.stringify(payload),
		});
		if ((response as any)?.data) {
			return (response as { data: Project }).data;
		}
		return response as Project;
	},
};
